﻿import { ColumnsBase, fieldsProxy } from "@serenity-is/corelib";
import { Column } from "@serenity-is/sleekgrid";
import { EmailQueuePriority } from "./EmailQueue.EmailQueuePriority";
import { EmailQueueRow } from "./EmailQueue.EmailQueueRow";

export interface EmailQueueColumns {
    MailId: Column<EmailQueueRow>;
    Uid: Column<EmailQueueRow>;
    Subject: Column<EmailQueueRow>;
    MailFrom: Column<EmailQueueRow>;
    MailTo: Column<EmailQueueRow>;
    ReplyTo: Column<EmailQueueRow>;
    Cc: Column<EmailQueueRow>;
    Bcc: Column<EmailQueueRow>;
    Priority: Column<EmailQueueRow>;
    Status: Column<EmailQueueRow>;
    LockExpiration: Column<EmailQueueRow>;
    RetryCount: Column<EmailQueueRow>;
    SentDate: Column<EmailQueueRow>;
}

export class EmailQueueColumns extends ColumnsBase<EmailQueueRow> {
    static readonly columnsKey = 'Serenity.Pro.EmailQueue.EmailQueueColumns';
    static readonly Fields = fieldsProxy<EmailQueueColumns>();
}

[EmailQueuePriority]; // referenced types